module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('site-header', [_c('h1', [_vm._v("Blog")])]), _vm._v(" "), _c('main', {
    staticClass: "wrap",
    class: _vm.$style.blog
  }, [_c('div', {
    class: _vm.$style.blogItems
  }, _vm._l((_vm.posts), function(post) {
    return _c('article', {
      class: _vm.$style.item
    }, [_c('router-link', {
      attrs: {
        "to": ("/blog/" + (post.slug))
      }
    }, [(_vm.getImage(post)) ? _c('div', {
      class: _vm.$style.thumbnail
    }, [_c('img', {
      attrs: {
        "src": _vm.getImage(post)
      }
    })]) : _vm._e(), _vm._v(" "), _c('p', {
      class: _vm.$style.meta
    }, [_vm._v(_vm._s(_vm.formatDate(post.date_gmt)))]), _vm._v(" "), _c('h2', {
      class: _vm.$style.title
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(post.title.rendered)
      }
    })])])], 1)
  }), 0)]), _vm._v(" "), (_vm.loading) ? _c('loader') : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-63790e92!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Blog.vue
// module id = 114
// module chunks = 2